import React from "react";
import Layout from "../layouts/GeneralLayout";
import ForgotPassword from "../screens/Account/ForgotPassword";

const MobileForgotPasswordPage = () => {
  return (
    <Layout>
      <ForgotPassword />
    </Layout>
  );
};

export default MobileForgotPasswordPage;
